(function () {
        var CLASS_NAME = 'tl-custom-cart-goal-container';

        function isVisible(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }

        function keepOnlyFirstVisible() {
          var elements = document.querySelectorAll('.' + CLASS_NAME);
          var foundVisible = false;

          elements.forEach(function (el) {
            if (isVisible(el)) {
              if (!foundVisible) {
                foundVisible = true;
              } else {
                el.style.display = 'none';
              }
            }
          });
        }

        // Chạy lần đầu khi script load
        keepOnlyFirstVisible();

        // Theo dõi DOM để xử lý các phần tử được thêm vào sau này
        var observer = new MutationObserver(function (mutations) {
          var shouldCheck = false;

          mutations.forEach(function (mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
              shouldCheck = true;
            }
          });

          if (shouldCheck) {
            keepOnlyFirstVisible();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      })();